import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { BitmapText, Container } from '@pixi/react';
import { useMemo } from 'react';
import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../../../redux/store';
import { LEADER_TEXT } from '../../../stringConstants';
import { withBitmapTextMetrics } from '../../../utils/textMetricsUtils';
import { isTestEnvironment } from '../../../utils/utils';
const LETTER_SPACING = 1;
export const PlayerChipLeaderDisplayContainer = ({ seatIndex }) => {
    const seatedPlayerId = useAppSelector((state) => state.poker.seatedPlayers[seatIndex]?.id);
    const chipsOrStatusTopRight = useAppSelector((state) => state.gameDimensions.chipsOrStatusTopRight, shallowEqual);
    const isChipLeader = useAppSelector((state) => {
        if (seatedPlayerId === undefined) {
            return false;
        }
        if (!state.poker.tourneyProperties) {
            // only show chip leader in tourneys
            return false;
        }
        if (state.poker.tourneyProperties.isMtt) {
            // MTT
            if (!state.mtt.activePlayers.length) {
                return false;
            }
            const chipLeader = state.mtt.activePlayers[0];
            if (chipLeader.id !== seatedPlayerId) {
                return false;
            }
            if (state.mtt.activePlayers.length === 1) {
                // probably never happens in reality, as the game will move directly from 2 active players to none at the end of the game
                return true;
            }
            // is chip leader only if not tied with second place
            return chipLeader.numChips > state.mtt.activePlayers[1].numChips;
        }
        else {
            // STT
            // TODO: Support chip leader display in STTs:
            // Keep in mind that if this would be determined from current chips, we'll want to store the player's chips at the start of the hand,
            // and use that value to determine chip leader display. Otherwise, if the chip leader goes all-in, they would no longer show as chip leader
            // and it may appear on another player that started the hand with fewer chips.
            return false;
        }
    });
    const { dimensions } = useMemo(() => withBitmapTextMetrics({
        text: LEADER_TEXT,
        bitmapTextStyleType: 'chip-leader'
    }, { letterSpacing: LETTER_SPACING }), []);
    if (!isChipLeader || !chipsOrStatusTopRight) {
        return null;
    }
    const x = chipsOrStatusTopRight.x;
    const y = Math.round(chipsOrStatusTopRight.y - dimensions.h + 10);
    return (_jsx(Container, { interactiveChildren: false, x: x, y: y, children: _jsx(BitmapText, { "pixi-data": isTestEnvironment() ? { type: 'chip-leader-text', seatIndex } : null, text: LEADER_TEXT, style: { fontName: 'chip-leader', letterSpacing: LETTER_SPACING }, roundPixels: true, anchor: [1, 0] }) }));
};
